import React from 'react';
import { DisclaimerFeatureModel } from '../../../../fetch-data/graphql/types';
import { DisclaimerFeatureContainer } from './styles';
import { renderMarkdown } from '../ContentFeature/overrides/markdown';

interface DisclaimerFeatureProps {
  feature: DisclaimerFeatureModel;
  isModal?: boolean;
}

export const DisclaimerFeature = ({
  feature,
  isModal,
}: DisclaimerFeatureProps) => {
  if (!feature.disclaimerContent.html) return null;

  return (
    <DisclaimerFeatureContainer $isModal={isModal}>
      {renderMarkdown({ text: feature.disclaimerContent.html! })}
    </DisclaimerFeatureContainer>
  );
};
